import { Stack, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import plug from '@assets/icons/plug-logo.png'
import Button from '@components/Button'
import { createWallet } from '@plug-core/handlers/walletActions/wallet'
import { useCurrentWallet } from '@plug-core/state'
import { logger } from '@plug-core/logger'

export const WalletSetupOptions = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { setCurrentWallet } = useCurrentWallet()

  const onNewWallet = useCallback(async () => {
    createWallet()
      .then((response) => {
        navigate(WALLET_SETUP_ROUTES.BACKUP_SEED, {
          state: { mnemonic: response.mnemonic },
        })
        setCurrentWallet(response.principal)
      })
      .catch((e) => logger.error('Failed to create wallet', { originalError: e }))
  }, [])

  return (
    <Stack
      direction="column"
      spacing={2}
      alignContent="center"
      justifyContent="center"
      flex={1}
      height="100%"
      justifyItems="center"
      px={4}
    >
      <img src={plug} width="120px" style={{ alignSelf: 'center' }} />
      <Stack spacing={1}>
        <Typography fontWeight="bold" textAlign="center" variant="h5">
          {t('welcome.title')}
        </Typography>
        <Typography textAlign="center" variant="body2" color="text.secondary">
          {t('welcome.description')}
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <Button variant="rainbow" fullWidth onClick={onNewWallet}>
          {t('welcome.create')}
        </Button>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate(WALLET_SETUP_ROUTES.IMPORT_SEED)}
        >
          {t('welcome.import')}
        </Button>
      </Stack>
    </Stack>
  )
}
